export enum PAYMENT_METHODS_ENUM {
  CARD = "card",
  TRANSFER = "transfer",
  CASH = "cash",
  PAYOUTS = "payouts",
  PAYOUTS_CASH = "payouts-cash",
  PAYOUTS_TRANSFER = "payouts-transfer",
  PAYOUTS_CARD = "payouts-card",
}

export const SETTLEMENT_DISTRIBUTION_PAYMENT_METHODS: PAYMENT_METHODS_ENUM[] = [
  PAYMENT_METHODS_ENUM.PAYOUTS_CASH,
  PAYMENT_METHODS_ENUM.PAYOUTS_TRANSFER,
  PAYMENT_METHODS_ENUM.PAYOUTS_CARD,
];

export const PROCESSOR_STATUS_ACTIVE = "active";
